module.exports = __webpack_public_path__ + "media/src/images/icons/edit-6958f6d5ffd9f6af2a5bad521fb25e92.svg";